import React,  { useState, useEffect }  from 'react';
import { verifyCodeSMSMission } from '../../api/commande';
import { StyledInput } from '../../Containers/PasserCommande/PasserCommande.styles';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import Modal from 'react-modal';
import moment from 'moment';
import { Clock, Route, AlertTriangle } from 'lucide-react';
import { convertMinutesToHHMM } from '../../utils/formatters';
import { useTranslation } from 'react-i18next';

function MissionCard({
  hideAssign = false,
  hideRouteLettre=false,
  hideHistoryChauffeur = false,
  hidecancel = false,
  hideFiles = false,
  hideAddForfait = false,
  hideValidateMission = false,
  hideChauffeur = false,
  mission,
  index,
  setChargement,
  onClickPlaces = () => {},
  onClickForfaits = () => {},
  onClickAddForfait = () => {},
  onClickCancelMission = () => {},
  onClickFiles = () => {},
  onClickAttribuer = () => {},
  onClickTransferer = () => {},
  onClickHistoriqueChauffeur = () => {},
  onClickRouteLetters=()=>{}
}) {
  const [loading, setLoading] = useState(false);
  const [enteredCode, setEnteredCode] = useState('');
  const token = useSelector((state) => state.auth.token);
  const [modalIsOpenSignature, setModalIsOpenSignature] = useState(false);
  const {t} = useTranslation()
  const stats = [
    {
      label: t("ordered_km_package"),
      value: `${mission?.total_kilometrage || 0} km`,
      type: "planned",
      icon: Route,
    },
   
    {
      label: t("waypoint_mileage"),
      value: `${mission?.total_kilometrage_parcouru || 0} km`,
      type: "actual",
      icon: Route,
    },
   
    {
      label: t("duration_at_waypoints"),
      value: convertMinutesToHHMM(mission.total_horaire_parcouru),
      type: "actual",
      icon: Clock,
    },
    {
      label: t("ordered_hourly_package"),
      value: convertMinutesToHHMM(mission?.duree_mission || 0), 
      type: "planned",
      icon: Clock,
    },
    {
      label: t("excess_mileage"),
      value: `${mission?.depassement_kilometrage || 0} km`, 
      type: "alert",
      icon: AlertTriangle,
    },
    {
      label: t("overtime"),
      value: convertMinutesToHHMM(mission?.depassement_horaire || 0), 
      type: "alert",
      icon: AlertTriangle,
    },
  ];
  const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth <= 768);
  
  
    useEffect(() => {
      const checkIfMobile = () => {
        setSmallScreen(window.innerWidth <= 768);
      };
      window.addEventListener('resize', checkIfMobile);
  
      return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
  

  return (
    <div style={{
      width: "100%",
      fontFamily:"Montserrat', sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "flexStart",
      marginTop: "1rem",
      //padding:"0 3rem" 
    }}>
      <div 
      style={{
           width: '100%',
           background: '#E4EAF0',
           display: 'flex',
           flexDirection: 'column',
           padding: '1.5rem',
           borderRadius: '10px',
           marginBottom:"1rem" 
      }}>
        <div 
         style={{
          display: 'flex',
          flexDirection : isSmallScreen ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '1.5rem',
          gap: isSmallScreen ? '10px' : ''
        }}>
          <span style={{
             fontWeight: 'bold',
             color: '#51C7F2',
             fontSize: '1.125rem'
          }}>
            Mission N° {index + 1} {t("for_order")} {!!mission ? 'N°' + mission?.commande?.__id : ''}
          </span>
          {mission?.statut && (
            <span  style={{
              padding: "0.5rem 1rem",
              borderRadius: "20px",
              fontSize: "0.875rem",
              fontWeight: 500,
              backgroundColor:
                mission.statut === "init" ? "#FEF3C7" :
                mission.statut === "en-cours" ? "#DBEAFE" :
                mission.statut === "terminer" ? "#D1FAE5" :
                mission.statut === "annuler" ? "#FEE2E2" :
                "transparent", 
              color:
                mission.statut === "init" ? "#92400E" :
                mission.statut === "en-cours" ? "#1E40AF" :
                mission.statut === "terminer" ? "#065F46" :
                mission.statut === "annuler" ? "#991B1B" :
                "inherit", 
            }}>
              {mission?.statut === "init" && t("not_started")}
              {mission?.statut === "en-cours" && t("in_progress")}
              {mission?.statut === "terminer" && t("completed")}
              {mission?.statut === "annuler" && t("cancelled")}
            </span>
          )}
        </div>

        <div style={{
           display: 'grid',
           gridTemplateColumns: isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)',
           gap: '1rem',
           marginBottom: '1.5rem'
        }}>
          {stats.map((stat, i) => (
            <div key={i} 
            style={{
              padding: "1rem",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              backgroundColor:
                stat.type === "planned" ? "#EFF6FF" :
                stat.type === "actual" ? "#ECFDF5" :
                stat.type === "alert" ? "#FEF2F2" :
                "transparent",
            }}>
              <div 
              style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '0.5rem'
              }}>
                <stat.icon 
                style={{
                   width: "1.25rem",
                   height: "1.25rem",
                   color:
                   stat.type === "planned" ? "#3B82F6" :
                   stat.type === "actual" ? "#10B981" :
                   stat.type === "alert" ? "#EF4444" :
                  "inherit",
                 }} />
                <span 
                 style={{
                      color: '#4B5563',
                      fontSize: '0.875rem'
                }}
                >{stat.label}</span>
              </div>
              <span 
              style={{
              fontSize: "1.125rem",
              fontWeight: 600,
              color:
              stat.type === "planned" ? "#1E40AF" :
              stat.type === "actual" ? "#047857" :
              stat.type === "alert" ? "#B91C1C" :
              "inherit", 
              }}>{stat.value}</span>
            </div>
          ))}
        </div>

        <div  style={{
            display: 'grid',
            gridTemplateColumns: isSmallScreen ? 'repeat(1, 1fr)': 'repeat(2, 1fr)',
            gap: '2rem'
        }}>
          <div 
          style={{
             display: 'flex',
             flexDirection: 'column',
             gap: '0.75rem'
          }}>
            <div 
            style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("start_address")}:</span>
              <span 
              style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>{mission?.adresse_debut?.label}</span>
            </div>
            <div 
              style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("start_date")}:</span>
              <span 
              style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>{mission?.date_debut} {mission?.heure_debut}</span>
            </div>
            <div  
            style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}
            >
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("end_address")}:</span>
              <span 
              style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>{mission?.adresse_fin?.label}</span>
            </div>
            <div 
            style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("end_date")}:</span>
              <span 
              style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>{mission?.date_fin} {mission?.heure_fin}</span>
            </div>
            {mission?.date_debut_reel && (
              <div 
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap:'4px'
             }}>
                <span 
                style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}
              >{t("actual_start_date")}:</span>
                <span style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>
                  {moment(mission?.date_debut_reel).format('DD/MM/YYYY HH:mm')}
                </span>
              </div>
            )}
            {mission?.date_fin_reel && (
              <div 
               style={{
                display: 'flex',
                flexDirection: 'row',
                gap:'4px'
              }}>
                <span 
                style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("actual_end_date")}:</span>
                <span 
                style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>
                  {moment(mission?.date_fin_reel).format('DD/MM/YYYY HH:mm')}
                </span>
              </div>
            )}
            {mission?.date_signature && (
              <div 
               style={{
                display: 'flex',
                flexDirection: 'row',
                gap:'4px'
              }}>
                <span 
                style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("date_of_signature")}:</span>
                <span 
                style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>
                  {moment(mission?.date_signature).format('DD/MM/YYYY HH:mm')}
                </span>
              </div>
            )}
            {mission?.date_termination && (
              <div 
               style={{
                display: 'flex',
                flexDirection: 'row',
                gap:'4px'
              }}>
                <span 
                style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("completion_date")}:</span>
                <span 
                style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>
                  {moment(mission?.date_termination).format('DD/MM/YYYY HH:mm')}
                </span>
              </div>
            )}
          </div>

          <div style={{
             display: 'flex',
             flexDirection: 'column',
             gap: '0.75rem'
          }}>
            <div 
            style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("transport_type")}:</span>
              <span 
                style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>
                {mission.type_transport} : {mission.type_transport === 'Poids lourds' 
                  ? mission.vehicule_poids_lourds 
                  : mission.type_transport_details}
              </span>
            </div>
            <div style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>Options</span>
              <span 
                style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>
                {mission.type_transport === 'Poids lourds' 
                  ? mission.options_poids_lourds.join(', ') 
                  : mission.options_vehicule_leger.join(', ')}
              </span>
            </div>
            <div 
             style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("number_of_loaders")}:</span>
              <span 
                style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>
                {mission.nombre_rippeur === null || mission.nombre_rippeur === undefined 
                  ? '0' 
                  : mission.nombre_rippeur}
              </span>
            </div>
            <div 
             style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
               style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>
               {t("hazardous_materials")}:</span>
              <span 
                style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>{mission.danger ? t("yes") : t("no")}</span>
            </div>
            <div 
            style={{
               display: 'flex',
               flexDirection: 'row',
               gap:'4px'
            }}>
              <span 
              style={{
                  color: "#6B7280",
                  fontSize: "0.875rem",
                  marginBottom: "0.25rem"
              }}>{t("signed_mission")}:</span>
              <span 
              style={{
                  fontWeight: '500',
                  color: '#111827',
                  fontSize: "0.875rem",
                }}>{mission.signé ? t("yes") :t("no")}</span>
            </div>
          </div>
        </div>

        <div 
        style={{
              display: 'flex',
              flexWrap:'wrap' ,
              gap: '0.75rem',
              marginTop: '1.5rem',
              justifyContent: 'space-between',
              width: '100%'
        }}>
            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>

        

          {/* {(mission.statut === "en-cours" && !mission.signé && !hideAddForfait) && (
            <button onClick={onClickAddForfait} 
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius:'8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              backgroundColor: '#3B82F6',
              color: 'white'
            }}>
              Ajouter Forfait
            </button>
          )} */}

          {(!mission.signé && !hideValidateMission) && (
            <button onClick={() => setModalIsOpenSignature(true)} 
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius:'8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              backgroundColor: '#10B981',
              color: 'white'
            }}>
              {t("validate_mission")}
            </button>
          )}

          {!hideChauffeur && mission.chauffeurID && (
            <span style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#F3F4F6',
              borderRadius:'8px' ,
              fontWeight: '500',
              color: '#111827',
            }}>
              {mission.chauffeurID.first_name} {mission.chauffeurID.last_name}
            </span>
          )}

          {!hideAssign && !mission.chauffeurID && (mission.statut === 'init' || mission.statut === 'en-cours') && (
            <button onClick={onClickAttribuer} 
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius:'8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              backgroundColor: '#10B981',
              color: 'white'
            }}>
              {t("assign")}
            </button>
          )}

          {!hideAssign && mission.chauffeurID && (mission.statut === 'init' || mission.statut === 'en-cours') && (
            <button onClick={onClickTransferer} 
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius:'8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              backgroundColor: '#3B82F6',
              color: 'white'
            }}>
              {t("transfer")}
            </button>
          )}

          {!hideHistoryChauffeur && mission.chauffeurID && (
            <button onClick={onClickHistoriqueChauffeur} 
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius:'8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              backgroundColor: '#10B981',
              color: 'white'
            }}>
              {t("driver_history")}
            </button>
          )}

          
           
              <button onClick={onClickPlaces} 
               style={{
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius:'8px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                backgroundColor: '#10B981',
                color: 'white'
              }}>
                {t("stop_point")}
              </button>
              {/* <button onClick={onClickForfaits} 
               style={{
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius:'8px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                backgroundColor:'#3B82F6',
                color: 'white',
              }}>
                Forfaits supplémentaires
              </button> */}
           

          
          {((mission.statut === "init" || mission.statut === "en-cours") && !mission.signé && !hideRouteLettre) && (
            <button onClick={onClickRouteLetters} 
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius:'8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              backgroundColor: '#10B981',
              color: 'white'
            }}>
              {t("manage_waybills")}
            </button>
          )}
          {(!hidecancel && mission?.statut !== 'terminer' && mission?.statut !== 'annuler') && (
          <button
           onClick={onClickCancelMission}
           disabled={!mission?.statut === 'en-cours'}
           className="btn btn-cancel"
           style={{
            padding: '0.5rem 1rem',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '500',
            cursor: !(mission?.statut === 'en-cours') ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s',
            backgroundColor: !(mission?.statut === 'en-cours') ? '#ccc' : '#EF4444',
            color: 'white',
            opacity: !( mission?.statut === 'en-cours') ? 0.6 : 1
            }}
            >
          {t("cancel_mission")}
         </button>
        )}

          {((mission.statut === "init" || mission.statut === "en-cours") && !mission.signé && !hideFiles) && (
            <button onClick={onClickFiles} 
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius:'8px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              backgroundColor: '#10B981',
              color: 'white'
            }}>
              {t("manage_documents")}
            </button>
          )}
        </div>
        </div>
      </div>

      <Modal
    isOpen={modalIsOpenSignature}
    style={{
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: 15, 
            padding: '2rem',
            width: '400px', 
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
            border: 'none', 
        },
    }}
    contentLabel="Validation de la signature"
>
    <div
        style={{
            fontFamily: 'Montserrat',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 15,
            textAlign: 'center',
        }}
    >
        <div
            style={{
                fontWeight: 'bold',
                fontSize: 22, 
                color: '#51C7F2',
                marginBottom: '1rem', 
            }}
        >
            {t("validate_mission")}
        </div>

        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <span
                style={{
                    marginBottom: '0.75rem', 
                    color: '#333', 
                    fontSize: 14,
                }}
            >
                {t("enter_verification_code")}
            </span>
            <StyledInput
                type="text"
                placeholder="Code"
                value={enteredCode}
                onChange={(e) => setEnteredCode(e.target.value)}
                style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    marginBottom: '1.5rem', 
                    outline: 'none',
                }}
               
            />
        </div>

        <div
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <button
                onClick={async (e) => {
                    e.preventDefault();
					          if (!enteredCode) {
						        toast.error(t("verification_code_err"), {
							        style: {
								      fontFamily: 'Montserrat',
							       },
					        	});
						        return;
					         }
					          setLoading(true);
                    try {
                        const response = await verifyCodeSMSMission(
                            { missionId: mission._id, code: enteredCode },
                            token
                        );
                        if(response.status){
                          toast.success(response.message, {
                            style: {
                                fontFamily: 'Montserrat',
                            },
                        });
                        setChargement(true);
                        setModalIsOpenSignature(false); 
                        }else{
                          toast.error(response.message, {
                            style: {
                                fontFamily: 'Montserrat',
                            },
                        })
                        }
                        
                    } catch (error) {
                      if (error.response?.status === 400 && error.response?.data?.message === "Cette mission a déjà été signée.") {
                        toast.error(t("mission_signed"), {
                            style: {
                                fontFamily: 'Montserrat',
                            },
                        });
                      }else{
                        toast.error(t("transfer_request_err"), {
                          style: {
                              fontFamily: 'Montserrat',
                          },
                      });
                      }
                      
                    } finally {
                        setLoading(false);
                        setEnteredCode('');
                    }
                }}
                disabled={loading}
                style={{
                    width: '150px',
                    height: '50px',
                    background: '#5BBCEA',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'white',
                    borderRadius: 7,
                    fontFamily: 'Montserrat',
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    transition: 'background-color 0.3s ease',
                }}
                
            >
                {loading ? (
                    <div className="loader"></div>
                ) : (
                    t("confirm")
                )}
            </button>

            <button
                onClick={() => {
                    setModalIsOpenSignature(false);
                }}
                style={{
                    width: '150px',
                    height: '50px',
                    background: '#FF5B5B',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'white',
                    borderRadius: 7,
                    fontFamily: 'Montserrat',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#E54444')}
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#FF5B5B')}
            >
                {t("cancel")}
            </button>
        </div>
    </div>
    </Modal>
    </div>
  );
}

export default MissionCard;